
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend'; // Public locales se file read karne ke liye

i18n
  .use(Backend) // Public files read karne ka plugin lagaya
  .use(LanguageDetector) // User ki preferred language save rakhne ke liye
  .use(initReactI18next) // React wrapper ko initialize kiya
  .init({
    fallbackLng: 'en', // Agar koi language missing ho toh english load ho
    debug: false, // Deployment par warning logs band rakhne ke liye
    ns: ['translation'],          // 👈 Yeh add karein
  defaultNS: 'translation',

    // 🔄 Apni src/i18n.js mein backend ka section aise update karein:
    backend: {
      loadPath: '/locales/{{lng}}.json',
    },

    // Hamari teeno unique language keys jo aapki images mein hain
    supportedLngs: ['en', 'ur', 'ur-roman'],

    interpolation: {
      escapeValue: false // React runs safe natively against xss
    }
  });

export default i18n;